import styled from 'styled-components';

const Invalid = styled.div`
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: ${({ theme }) => theme.input.invalid};
  /* position: absolute; */

  &::first-letter {
    text-transform: capitalize;
  }
`;

export default Invalid;
